<template>
    <span class="badge" :class="className">
        <slot></slot>
    </span>
</template>

<script>
export default {
    name: 'Badge',
    props: {
        className: {
            type: String
        }
    }
}
</script>

<style scoped lang="scss">
.badge {
    padding: 5px 10px;
    border-radius: 11px;
    font-size: 75%;

    &--primary {
        color: $white;
        background: $primary;
    }

}
</style>
